import { toast } from 'react-toastify';
import { Context } from '../companyInfo';

const showError = (ctx: Context, evt) => {
    toast(evt.data.message);
};

export default showError;
